module.exports = __webpack_public_path__ + "static/media/preview_coupon_campaign_6.2b297213.svg";